// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-js": () => import("/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/src/templates/Page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

